











 





































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TeamMemberIntegrationAuthWebhook",
    "kind": "LinkedField",
    "name": "auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationProviderWebhook",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TeamNotificationSettings",
    "kind": "LinkedField",
    "name": "teamNotificationSettings",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "NotificationSettings_settings"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveIntegrationProviderMutation_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMemberIntegrations",
      "kind": "LinkedField",
      "name": "teamMemberIntegrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MattermostIntegration",
          "kind": "LinkedField",
          "name": "mattermost",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsIntegration",
          "kind": "LinkedField",
          "name": "msTeams",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgIntegrationProviders",
      "kind": "LinkedField",
      "name": "orgIntegrationProviders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationProviderOAuth2",
          "kind": "LinkedField",
          "name": "gitlab",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GitLabProviderRow_integrationProvider"
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serverBaseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveIntegrationProviderSuccess",
  "abstractKey": null
};
})();

(node ).hash = "1532180637f28627bd9cb7ac2dcfce12";

export default node;
